<template>
  <v-container luid>
    <base-material-card icon="mdi-check-circle" :title="'Proyectos en Aprobación'" class="px-5 py-3">
      <v-row>
        <v-col cols="12">
        </v-col>
      </v-row>
      <v-data-table 
          v-if="proyectos.length > 0" 
          :headers="projectTableHeaders" 
          :items="proyectos" 
          item-key="id" 
          :search="searchProjectQuery"
          class="elevation-1">
        <template v-slot:top>
          <v-text-field 
            v-model="searchProjectQuery" 
            outlined 
            label="Buscar en proyectos..." 
            class="mx-4" />
        </template>
        <!-- <template v-slot:item.cotizacion="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon 
                small 
                class="mr-2"
                :class="item.cotizacion ? 'black--text' : ''" 
                v-bind="attrs" 
                v-on="on" 
                @click="openLink(item.cotizacion)"
              >
                mdi-file-pdf-box
              </v-icon>
            </template>
            <span>Ver Cotización</span>
          </v-tooltip>
        </template>

        <template v-slot:item.copiaCorreo="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                :class="item.copiaCorreo ? 'black--text' : ''"
                v-bind="attrs"
                v-on="on"
                @click="openLink(item.copiaCorreo)"
              >
                mdi-email-open-outline
              </v-icon>
            </template>
            <span>Ver Correo</span>
          </v-tooltip>
        </template> -->

        <template v-slot:item.estadoAprobacionToString="{ item }">
          <v-chip
            :color="vChipColor(item.estadoAprobacionToString)"
            dark
            small
          >
            {{ item.estadoAprobacionToString }}
          </v-chip>
        </template>


        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="inspectProject(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Ver detalles</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="$store.getters.hasPermission('Proyectos', 'Aprobación')"
                      small 
                      class="mr-2" 
                      v-bind="attrs" 
                      v-on="on" 
                      @click="openApprovalDialog(item)">
                mdi-checkbox-marked-circle
              </v-icon>
            </template>
            <span>Aprobar proyecto</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="$store.getters.hasPermission('Proyectos', 'Aprobación')"
                      small 
                      class="mr-2" 
                      v-bind="attrs" 
                      v-on="on" 
                      @click="openRejectDialog(item)">
                mdi-close-thick
              </v-icon>
            </template>
            <span>Rechazar proyecto</span>
          </v-tooltip>

        </template>
      </v-data-table>

      <v-alert v-else type="info" elevation="2" class="mt-4">
        No hay proyectos en espera de aprobación.
      </v-alert>
    </base-material-card>

    <v-dialog v-model="isApprovalDialogVisible" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Confirmar Aprobación</span>
        </v-card-title>
        <v-card-text>
          <p>¿Está seguro de que desea Aprobar este proyecto y enviarlo a Negociación?</p>
          <div v-if="selectedProjectData">
            <p><strong>Proyecto:</strong> {{ selectedProjectData.nombre }}</p>
            <p><strong>Código:</strong> {{ selectedProjectData.codigo }}</p>
            <p><strong>Región:</strong> {{ selectedProjectData.region }}</p>
            <p><strong>Fecha de Entrega:</strong> {{ selectedProjectData.entrega }}</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
           <v-btn color="grey" @click="cancelApproval" text>Cancelar</v-btn>
          <v-btn color="primary" @click="approveProject(selectedProjectData)" text>Aprobar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isRejectDialogVisible" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Confirmar Rechazo del Proyecto</span>
        </v-card-title>
        <v-card-text>
          <p>¿Está seguro de que desea Rechazar este proyecto y devolverlo a Prospección?</p>
          <div v-if="selectedProjectData">
            <p><strong>Proyecto:</strong> {{ selectedProjectData.nombre }}</p>
            <p><strong>Código:</strong> {{ selectedProjectData.codigo }}</p>
            <p><strong>Región:</strong> {{ selectedProjectData.region }}</p>
            <p><strong>Fecha de Entrega:</strong> {{ selectedProjectData.entrega }}</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" @click="cancelReject" text>Cancelar</v-btn>
          <v-btn color="primary" @click="rejectProject(selectedProjectData)" text>Rechazar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isProjectDetailsDialogVisible" max-width="600px">
      <v-card>
        <v-card-title>Detalles del Proyecto</v-card-title>
        <v-card-text v-if="selectedProjectData">

          <div v-for="(item, index) in filteredProjectFields" :key="index">
            <strong>{{ item.label }}:</strong>
            <span v-if="isUrl(item.value)">
              <a :href="item.value" target="_blank" rel="noopener">Ver archivo</a>
            </span>
            <span v-else>
              {{ item.value }}
            </span>
          </div>

          
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="isProjectDetailsDialogVisible = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar 
      v-model="isSnackBarVisible" 
      :color="snackbarColor" 
      :timeout="1700" 
      top
      >
      {{ snackbarMessage }}
      <template 
        v-slot:action="{ attrs }">
        <v-btn 
          text 
          v-bind="attrs" 
          @click="isSnackBarVisible = false"
          >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  data() {
    return {
      nombre:"",
      cotizacion:"",
      copiaCorreo:"",
      searchProjectQuery:"",
      snackbarMessage:"",
      snackbarColor:"",
      isProjectDetailsDialogVisible:false,
      selectedProjectData:null,
      isProjectsTableLoading: true,
      isApprovalDialogVisible:false,
      isRejectDialogVisible:false,
      isSnackBarVisible:false,
      proyectos: [],
      projectTableHeaders: [
        { text: 'Proyecto', 
          align: 'start', 
          value: 'nombre', 
          sortable: true 
        },
        { text: 'Asesor', 
          align: 'center', 
          value: 'asesor', 
          sortable: false 
        },
        { text: 'Prospectado el', 
          align: 'center', 
          value: 'propectadoAt', 
          sortable: false 
        },
        /* { text: 'Cotización', 
          align: 'center', 
          value: 'cotizacion', 
          sortable: false 
        },
        { text: 'Correo de Confirmación', 
          align: 'center', 
          value: 'copiaCorreo', 
          sortable: false 
        }, */
        { text: 'Estado del Proyecto', 
          align: 'center', 
          value: 'estadoAprobacionToString', 
          sortable: false 
        },
        { text: 'Acciones', 
          align: 'center', 
          value: 'actions', 
          sortable: false 
        },
      ],
      fieldLabels: {
        codigo: 'Código del Proyecto',
        nombre: 'Nombre del Proyecto',
        direccion: 'Dirección',
        region: 'Región',
        provincia:'Provincia',
        categoria:'Categoría del Proyecto',
        tipo:'Tipo de Proyecto',
        etapa: 'Etapa',
        constructora:'Constructora',
        inmobiliaria:'Inmobiliaria',
        foto:"Foto del proyecto", 
        cotizacion:"Cotización",
        copiaCorreo:"Correo de Confirmación",
        proveedorActual:'Proveedor Actual',
        numeroPisos:'Cantidad de Pisos',
        numeroDepartamentos:'Cantidad de Departamentos',
        cantidadPuertas:'Cantidad de Puertas',
        cantidadCortafuego:'Cantidad de Cortafuegos',
        asesor : 'Asesor',
        prospector:'Prospector',
        quienProspecto:'Prospectado por',
        propectadoAt:'Fecha de Prospección',
        entrega:'Fecha de Entrega',
        contactoNegociacion:'Contacto',
      }
    }
  },
  computed: {
    filteredProjectFields() {
      if (!this.selectedProjectData) return []
      return Object.keys(this.fieldLabels)
        .filter(key => this.selectedProjectData[key] && this.fieldLabels[key])
        .map(key => ({
          label: this.fieldLabels[key],
          value: this.selectedProjectData[key]
        }));
    }
},
  mounted() {
    this.getInApprovalProjects()
  },
  methods: {
    getInApprovalProjects() {
      const firestoreDB = firebase.firestore()
      firestoreDB.collection('proyectos')
        .where('fase', '==', 2) 
        .onSnapshot(projectsSnapshot => {
          this.proyectos = projectsSnapshot.docs.map(projectDoc => {
            const data = projectDoc.data()
            return {
              id: projectDoc.id,
              ...data,
              estadoAprobacionToString: Array.isArray(data.estadoAprobacion) ? data.estadoAprobacion[0] : data.estadoAprobacion || '—'
            }
          })
          this.isProjectsTableLoading = false
        })
    },
    inspectProject(item) {
      const excludedProjectFields =['id','estadoNegociacion',
        'montoCortafuego','comentarios','visitas','dateFechaFacturacion','razonPerdido',
        'estado','fechaCreacion','fase','ipv','tipoSistema','dateFechaCotizacion',
        'quienGano','tipoCliente','medioContacto','tipoVivienda','reunion',
        'quienGano','montoPuertas','tipoCliente','fechaEdicion','montoCerraduras',
        'posibilidadCierre','planos','comments','longitud','latitud','cantidadDuctos',"metrados"
      ];
      this.selectedProjectData = Object.fromEntries(
        Object.entries(item).filter(([key]) => !excludedProjectFields.includes(key))
      );
      this.isProjectDetailsDialogVisible = true;
    },
    openApprovalDialog(proyecto) {
      this.selectedProjectData = proyecto; 
      this.isApprovalDialogVisible = true;
    },
    cancelApproval(){
      this.isApprovalDialogVisible=false;
    },
    openRejectDialog(proyecto) {
      this.selectedProjectData = proyecto; 
      this.isRejectDialogVisible = true;
    },
    cancelReject(){
      this.isRejectDialogVisible=false;
    },
    approveProject(proyecto) {
      const firestoreDB = firebase.firestore();
      const user = JSON.parse(localStorage.userAuth);
      const automaticApproveComment = {
        usuario: user.email,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        comment: "⚙️ El proyecto fue aprobado y pasó a negociación",
      };
      firestoreDB.collection('proyectos')
        .doc(proyecto.id)
        .update({
          fase: 3,
        })
        .then(() => {
          firestoreDB.collection('proyectos')
            .doc(proyecto.id)
            .update({
              comments: firebase.firestore.FieldValue.arrayUnion(automaticApproveComment),
            })
            .then(() => {
              this.snackbarMessage = "Proyecto Aprobado";
              this.snackbarColor = "green darken-2";

              this.logAutomaticComment(
                proyecto.codigo,
                "⚙️ El proyecto fue aprobado y pasó a negociación",
                proyecto
              );
            })
            .catch((error) => {
              alert('Error al agregar comentario: ' + error.message);
            });
        })
        .catch((error) => {
          alert('Error al aprobar el proyecto: ' + error.message);
        });

      this.isSnackBarVisible = true;
      this.isApprovalDialogVisible = false;
    },
    rejectProject(proyecto) {
      const firestoreDB = firebase.firestore();
      const usuario = JSON.parse(localStorage.userAuth).email;
      const now = firebase.firestore.Timestamp.fromDate(new Date());

      const automaticRejectComment = {
        usuario: usuario,
        createdAt: now,
        comment: "⚙️ El proyecto fue rechazado en la fase de aprobación."
      };

      firestoreDB.collection('proyectos')
        .doc(proyecto.id)
        .update({
          estadoAprobacion: "Rechazado",
          comments: firebase.firestore.FieldValue.arrayUnion(automaticRejectComment)
        })
        .then(() => {
          this.snackbarMessage = "Proyecto rechazado";
          this.snackbarColor = "yellow darken-2";

          this.logAutomaticComment(
            proyecto.codigo,
            "⚙️ El proyecto fue rechazado en la fase de aprobación.",
            proyecto
          );
        })
        .catch((error) => {
          console.log(error);
          /* this.snackbarMessage = "Mensaje de fracaso";
          this.snackbarColor = "yellow darken-2"; */
        });

      this.isSnackBarVisible = true;
      this.isRejectDialogVisible = false;
    },
    openLink(url) {
      console.log("Intentando abrir:", url);
      if (url) {
        window.open(url, '_blank');
      } else {
        alert('Archivo no disponible.');
      }
    },
    vChipColor(estado) {
      switch (estado) {
        case 'Rechazado':
          return 'red lighten-2';
        case 'Por aprobar':
          return 'grey';
        default:
          return 'blue lighten-1';
      }
    },
    isUrl(value) {
      try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (_) {
        return false;
      }
    },
    logAutomaticComment(codigo, comentario, proyectoData) {
      const user = JSON.parse(localStorage.userAuth);
      const logData = {
        codigoProyecto: codigo,
        nombreProyecto: proyectoData.nombre || '',
        comentario: comentario,
        usuario: user.email,
        perfil: user.perfil,
        fecha: firebase.firestore.Timestamp.fromDate(new Date()),
        estadoNegociacion: proyectoData.estadoNegociacion || '',
        constructora: proyectoData.constructora || '',
        inmobiliaria: proyectoData.inmobiliaria || '',
        tipo: proyectoData.tipo || '',
        region: proyectoData.region || '',
        provincia: proyectoData.provincia || '',
        fase: proyectoData.fase || 1,
        asesor: proyectoData.asesor || user.email,
        prospector: proyectoData.prospector || user.email
      };

      return firebase.firestore().collection('globalLog').add(logData);
    },
  }
}
</script>

<style scoped>
</style>
